import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { questionReactionSelector } from '../../store/selectors';
import { setQuestionReaction } from '../../store/actions';
import { reactions } from '../../constants/common';
import QuestionReactionIcon from '../QuestionReactionIcon/QuestionReactionIcon';
import useFilterChange from '../../hooks/useFilterChange';
import styles from './SelectReaction.module.scss';

const SelectReaction = ({ className }) => {
  const reaction = useSelector(questionReactionSelector);

  const [value, setValue] = useState(reaction);

  const change = useFilterChange({ action: setQuestionReaction });

  const handleChange = (value) => {
    setValue(value);
    change(value);
  };

  useEffect(() => {
    setValue(reaction);
  }, [reaction]);

  return (
    <Select
      className={className}
      placeholder="Оценка ответа"
      value={value}
      onChange={handleChange}
      allowClear
    >
      {Object.values(reactions).map((reaction) => (
        <Select.Option key={reaction.id} value={reaction.id}>
          <p className={styles.optionContent}>
            <QuestionReactionIcon reactionName={reaction.id} />
            <span>{reaction.content}</span>
          </p>
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectReaction;
